import { render, staticRenderFns } from "./BillingPreview.vue?vue&type=template&id=70744b6e&scoped=true"
import script from "./BillingPreview.vue?vue&type=script&lang=js"
export * from "./BillingPreview.vue?vue&type=script&lang=js"
import style0 from "./BillingPreview.vue?vue&type=style&index=0&id=70744b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70744b6e",
  null
  
)

export default component.exports